import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=31b1e2e0&scoped=true&"
import script from "./RefundPolicy.vue?vue&type=script&lang=ts&"
export * from "./RefundPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=31b1e2e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1e2e0",
  null
  
)

export default component.exports